import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DualListBox from 'react-dual-listbox';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { addMarket } from '../../../../slices/auth/settings/thunk';
import { createSelector } from 'reselect';
import { toggleAddMarketModal } from '../../../../slices/modals/reducer';
import country from '../../../../common/country';
import ErrorAlert from '../../../../Components/Common/ErrorAlert';
import { resetMarketErr } from '../../../../slices/auth/settings/reducer';

/**
 * React component for adding market information in a modal.
 * @component
 */
function AddMarketModal() {
  const dispatch = useDispatch();
  const selectStates = createSelector(state => state, state => ({
    marketModal: state.Modal.addMarketModal,
    clientId: state.MenuData.clientPath,
    brandId: state.MenuData.brandPath,
    company: state.MenuData.client,
    brands: state.Settings.brands,
    marketErr: state.Settings.marketErr,
    marketErrMsg: state.Settings.marketErrMsg
  }));
  const { marketModal, clientId, brandId, company, brands, marketErr, marketErrMsg } = useSelector(selectStates);   
  const options = country.map(item => { return { value: item.name, label: item.name } })
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedOpt, setSelectedOpt] = useState([]);

  useEffect(() => {
    if (options && clientId && brandId) {
      const foundClient = company.clients.find(client => client._id === clientId);
      const foundBrand = foundClient.brands.find(brand => brand._id === brandId);
      const markets = foundBrand.markets; 
      setFilteredOptions(options.filter(option => !markets.some(market => market.name === option.label)));
    }
  }, [clientId, brandId]);

  /**
  * Handles the addition of a new market.
  * @param {Event} e - The event object.
  */
  async function handleAddMarket(e) {
    e.preventDefault();
    const foundBrand = brands.find((item) => item._id === brandId);

    if (foundBrand) {
      let dataObj = {};
      dataObj.markets = selectedOpt;
      dataObj.brandId = brandId;
      dataObj.clientId = clientId;
      dataObj.webSite = foundBrand.webSite;
      const isMarketCreated = await dispatch(addMarket(dataObj));
      if (isMarketCreated && typeof isMarketCreated !== 'object') {
        closeModal();
      }
    }
  }

  function closeModal() {
    dispatch(toggleAddMarketModal());
    setTimeout(() => {
      setSelectedOpt([]);
    }, 200);
  }
  return (
    <Modal isOpen={marketModal} toggle={closeModal} centered size='lg'>
      <ModalHeader className="p-3" toggle={closeModal}>Add Market</ModalHeader>
      <form className="tablelist-form" onSubmit={handleAddMarket}>
        <ModalBody>
          <Row>
            <Col>
              <ErrorAlert errorState={marketErr} errorMessage={marketErrMsg} resetError={resetMarketErr} />
            </Col>
          </Row>
          <Row>
            <Col>
              <label htmlFor='markets'>Markets</label>
              <DualListBox
                id="market"
                canFilter
                filterCallback={(options, filterInput) => {
                  if (filterInput === "") {
                    return true;
                  }
                  return new RegExp(filterInput, "i").test(options.label);
                }}
                filterPlaceholder="Search..."
                options={filteredOptions}
                selected={selectedOpt}
                onChange={(e) => setSelectedOpt(e)}
                icons={{
                  moveLeft: <span className="mdi mdi-chevron-left" key="key" />,
                  moveAllLeft: [
                    <span className="mdi mdi-chevron-double-left" key="key" />,
                  ],
                  moveRight: <span className="mdi mdi-chevron-right" key="key" />,
                  moveAllRight: [
                    <span className="mdi mdi-chevron-double-right" key="key" />,
                  ]
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            <button type="button" className="btn btn-light" onClick={closeModal}>Close</button>
            <button type="submit" className="btn btn-success" id="add-btn">
              Add Market
            </button>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  )
}

export default AddMarketModal
